import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';

/** Componente que recibe como parametro:
 * titulo: string
 * content: any
 * confirm: boolean (en caso que se trate de un modal de confirmación
 * si se marco true a confirm: emite un Event: 'alerta'
 */

 @Component({
  selector: 'custom-alert',
  templateUrl: './custom-alert.component.html',
  styleUrls: ['./custom-alert.component.scss']
})
export class CustomAlertComponent implements OnInit {

  @Input() titulo:string=''
  @Input() content:any=null
  @Input() confirm: boolean = false
  @Output() acepta = new EventEmitter<boolean>()
  constructor(config: NgbModalConfig, public activeModal: NgbActiveModal) {
    config.backdrop = 'static';
		config.keyboard = false;
  }

  ngOnInit(): void {
  }

  aceptar(valor:boolean){
    this.acepta.emit(valor)
    if(this.confirm === false) this.activeModal.close()
  }
}
